import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "../Page/Home/Home";
import Login from "../Page/Login/Login";
import { getUserMenu } from "../Service/MenuAPI";
import NotFound from "./NotFound";

const componentMapping = {
  /*** 자연으로농장 ***/
  "/FARM010": React.lazy(() => import("../Page/FARM010/FARM010")), // 개체 기본정보
  "/FARM020": React.lazy(() => import("../Page/FARM020/FARM020")), // 사육두수 현황
  "/FARM030": React.lazy(() => import("../Page/FARM030/FARM030")), // 수정기록
  "/FARM040": React.lazy(() => import("../Page/FARM040/FARM040")), // 진료기록
  "/FARM050": React.lazy(() => import("../Page/FARM050/FARM050")), // 진료기록

  /*** 스마트 낙농단지 ***/
  "/MOB010": React.lazy(() => import("../Page/MOB010/MOB010")), // 사육두수 현황
  "/MOB020": React.lazy(() => import("../Page/MOB020/MOB020")), // 납유현황
  "/MOB030": React.lazy(() => import("../Page/MOB030/MOB030")), // 일자별 납유량
  // "/MOB040": React.lazy(() => import("../Page/MOB040/MOB040")), // 일별 개체별 착유량
  "/MOB050": React.lazy(() => import("../Page/MOB050/MOB050")), // 개체별 일별 착유량
  "/MOB060": React.lazy(() => import("../Page/MOB060/MOB060")), // 사육개체 현황
  // "/MOB070": React.lazy(() => import("../Page/MOB060/MOB070")), // 일별 사육두수 변화
  "/MOB080": React.lazy(() => import("../Page/MOB080/MOB080")), // 두당산유량 십분위 현황
  "/MOB090": React.lazy(() => import("../Page/MOB090/MOB090")), // 사육비 정산내역
  "/MOB100": React.lazy(() => import("../Page/MOB100/MOB100")), // 수정기록
  "/MOB110": React.lazy(() => import("../Page/MOB110/MOB110")), // 송아지 분만기록
  "/MOB120": React.lazy(() => import("../Page/MOB120/MOB120")), // 개체 기본정보
  "/MOB130": React.lazy(() => import("../Page/MOB130/MOB130")), // 두당산유량 분포 현황
  "/MOB140": React.lazy(() => import("../Page/MOB140/MOB140")), // 진료기록
  "/MOB150": React.lazy(() => import("../Page/MOB150/MOB150")), // 송아지 분만기록
  "/MOB160": React.lazy(() => import("../Page/MOB160/MOB160")), // 송아지 현황 조회
  "/MOB170": React.lazy(() => import("../Page/MOB170/MOB170")), // 일별 개체별 착유량
  "/MOB180": React.lazy(() => import("../Page/MOB180/MOB180")), // 월별 검정성적
  "/MOB190": React.lazy(() => import("../Page/MOB190/MOB190")), // 개체별 검정성적
};

const Router = () => {
  const [filteredMenu, setFilteredMenu] = useState([]);
  const userId = localStorage.getItem("userId");
  const userDiv = localStorage.getItem("userDiv");
  const location = useLocation();

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const menus = await getUserMenu(userDiv);

        if (Array.isArray(menus)) {
          setFilteredMenu(menus);
        } else {
          setFilteredMenu([]);
        }
      } catch (error) {
        setFilteredMenu([]);
      }
    };

    fetchMenus();
  }, []);

  if (filteredMenu === null) {
    return <div></div>;
  }

  const validPaths = filteredMenu.map((menu) => menu.menuPath);

  if (
    !validPaths.includes(location.pathname) &&
    location.pathname !== "/" &&
    location.pathname !== "/HOME"
  ) {
    return <NotFound />;
  }

  return (
    <Routes>
      <Route path="/" exact element={<Login />} />
      <Route path="/HOME" exact element={<Home />} />
      {Array.isArray(filteredMenu) &&
        filteredMenu.map((menu) => {
          const Component = componentMapping[menu.menuPath];
          if (!Component) {
            return null;
          }
          return (
            <Route
              key={menu.menuPath}
              path={menu.menuPath}
              element={
                <React.Suspense>
                  <Component />
                </React.Suspense>
              }
            />
          );
        })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
